import React, { ReactElement, useState, useEffect } from "react";
import CardActions from '@mui/material/CardActions';
import QuestionBox from "../box";
import QuestionValue from "../value";
import { FileQuestionSpec, QuestionDocument, QuestionEditorProps, Value } from '../../../types/types';
import QuestionEditorButton from "../questioneditorbutton";
import QuestionLabel from '../label';
import FileFieldEditor from '../../field/editors/filefieldeditor';

function FileQuestionEditor(props: QuestionEditorProps<FileQuestionSpec>) : ReactElement {
  const [value, setValue] = useState<Value>(props.answer?.value as QuestionDocument);

  useEffect(() => {
    setValue(props.answer?.value as QuestionDocument);
  }, [props.answer]);

  return (
    <QuestionBox>
      <QuestionLabel spec={props.spec} />
      <QuestionValue>
        <FileFieldEditor value={value as QuestionDocument || undefined} setValue={setValue} id={props.buttonsSettings.id} buttonsSettings={props.buttonsSettings} />
      </QuestionValue>
      <CardActions>
        <QuestionEditorButton response={value} setResponse={setValue} defaultValue={props.answer?.value} buttonsSettings={props.buttonsSettings} hideDraft />
      </CardActions>
    </QuestionBox>
  );
}
export default FileQuestionEditor;
